import "./App.css";
import FaucetForm from "./components/FaucetForm";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const SWrapper = styled.div`
  will-change: transform, opacity;
  height: auto;
  animation: ${fadeIn} 0.7s ease 0s normal 1;
  min-height: 200px;
  display: block;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const SDiv = styled.div`
  max-width: 420px px;
  width: 100%;
  max-width: 420px;
  width: 100%;
  background: rgb(255, 255, 255);
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(25 32 98 / 8%) 0px 8px 43px;
  border-radius: 14px;
`;

function App() {
  return (
    <div className="App">
      <SDiv>
        <i className="fa fa-bath" aria-hidden="true" style={{ fontSize:"80px",padding: '1rem'}}></i>
        <h1 style={{ textAlign: "center" }}>AllianceDEX Faucet</h1>
        <SWrapper>
          <FaucetForm />
        </SWrapper>
      </SDiv>
    </div>
  );
}

export default App;
